module.exports = __webpack_public_path__ + "mf.d7c64c34c69ae2497ddb.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mf.svg
// module chunks = styles